import { getURLParam } from 'helpers/url';

const REDIRECT_URI_PARAM = 'oauth_redirect_uri';

export function addTokenToRedirect(redirectURI, firebaseToken) {
  let redirectURL;
  if (redirectURI.startsWith('https://')) {
    redirectURL = new URL(redirectURI);
  } else {
    redirectURL = new URL(redirectURI, window.location.origin);
  }

  redirectURL.searchParams.set('firebase_token', firebaseToken);
  return redirectURL.href;
}

export function isOAuthRedirect() {
  const encodedRedirectURI = getURLParam(REDIRECT_URI_PARAM);
  return encodedRedirectURI !== null && encodedRedirectURI !== '';
}

export async function handleOAuthRedirect(user) {
  const encodedRedirectURI = getURLParam(REDIRECT_URI_PARAM);
  const redirectURI = decodeURIComponent(encodedRedirectURI);
  const firebaseToken = await user.getIdTokenFromNative();

  const redirectURL = addTokenToRedirect(redirectURI, firebaseToken);
  window.location = redirectURL;
}
